import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from './../../../../themes/default';

const styles = theme => ({
  root: {
    //paddingTop: theme.spacing.unit * 1.5,
    paddingBottom: theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 1.5,
    borderBottom: `5px solid ${ theme.palette.grey[200] }`,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    flex: '0 0 auto'
  },
  spacer: {
    flex: '1 1 100%'
  },
  bold: {
    fontWeight: 600
  }
});

const HeadlineThird = ({ title, actions, classes }) => {

  return (
    <div className={ classes.root }>

      <div className={ classes.title }>
        <Typography component="p" variant="body2" className={ classes.bold }>
          { title }
        </Typography>
      </div>

      <div className={ classes.spacer } />

      { actions && (
        <div className={ classes.actions }>
          { actions }
        </div>
      )}

    </div>
  )

}

HeadlineThird.propTypes = {
  title: PropTypes.string.isRequired
};


export default withStyles(styles)(HeadlineThird);
